import React from 'react';
import { InnerLayout } from '@layout';
import MeetAradhna from './MeetAradhna';
import Awards from './Awards';
import Videos from './Videos';

export default function About({
  title = 'About Aradhna Tripati',
  h1 = 'Aradhna Tripati',
  ...restProps
}) {
  return (
    <InnerLayout
      title={title}
      h1={h1}
      {...restProps}
    >
      <MeetAradhna />
      <Awards />
      <Videos />
    </InnerLayout>
  );
}
